import { store } from 'app/store';
import { selectUser } from 'features/authentication/reducers/userSlice';

export enum MetricType {
  create_analytics = 'dataops-create-analytics-step',
  create_analytics_end = 'dataops-create-analytics-end',
  create_dbt = 'dataops-create-dbt-step',
  create_dbt_end = 'dataops-create-dbt-end',
  create_dbt_video_view = 'dataops-create-dbt-video-view',
  create_dynamic_delivery = 'dataops-create-dynamic-delivery-step',
  create_dynamic_delivery_end = 'dataops-create-dynamic-delivery-end',
  create_az = 'dataops-create-az-step',
  create_az_end = 'dataops-create-az-end',
  create_az_monitoring = 'dataops-create-az-monitoring',
  create_native_app = 'dataops-create-native-app-step',
  create_native_app_end = 'dataops-create-native-app-end',
  create_data_science = 'dataops-create-data-science-step',
  create_streamlit = 'dataops-create-streamlit-step',
}

export enum ExitTo {
  developer = 'develop',
  pipeline = 'pipeline',
  platform_repo = 'platform-repo',
  snowsight = 'snowsight',
}

export function sendMetrics(metric: MetricType, flowStep?: string | null, exitTo?: ExitTo): void {
  // Get the user ID from the Redux store
  const state = store.getState();
  const userId = selectUser(state);

  const token = getAuthTokenFromStorage();

  // Create a function to send the actual metrics after hashing is complete
  const sendMetricsWithHash = (hashedToken: string | null): void => {
    const body = {
      event_name: metric,
      event_version: 1,
      event_source: 'create.dataops.live',
      properties: {
        user_id: userId,
        flow_step: flowStep,
        flow_exit: exitTo ?? null,
        session_id: hashedToken,
        environment: process.env.REACT_APP_ENV,
      },
    };
    console.log(body);
    fetch('https://metrics-ingest.dataops.live/metric', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  // If we have an auth token, hash it first, then send metrics
  if (token !== null) {
    void hashString(token)
      .then(sendMetricsWithHash)
      .catch((error) => {
        console.error('Error hashing auth token:', error);
      });
  } else {
    // If no auth token, send metrics with null session_id
    sendMetricsWithHash(null);
  }
}

const getAuthTokenFromStorage = (): string | null => {
  const token = localStorage.getItem('ROCP_token');
  if (token !== null) {
    try {
      return JSON.parse(token);
    } catch (error) {
      console.warn(`Failed to parse stored token from localStorage: ${String(error)}`);
    }
  }
  return null;
};

// Simple hash function using SHA-256
const hashString = async (str: string): Promise<string> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
};
